/**
 * 用户管理翻译 - 中文
 * Users - Chinese
 */
export const usersZh = {
  // 页面标题
  title: '用户管理',
  subtitle: '管理系统用户和权限',
  
  // 验证消息
  requiredFields: '请填写所有必填字段',
  passwordTooShort: '密码长度至少6位',
  
  // 创建用户
  createLocal: '创建本地用户',
  fillUserInfo: '填写用户信息',
  createSuccess: '用户创建成功',
  createFailed: '用户创建失败',
  
  // Entra ID 同步
  ldapSync: 'Entra ID 同步',
  syncing: '同步中...',
  confirmSync: '确定要同步 Entra ID 用户数据吗？',
  syncSuccess: 'Entra ID 同步完成',
  syncFailed: 'Entra ID 同步失败',
  lastSync: '最后同步',
  never: '从未同步',
  created: '新增',
  updated: '更新',
  skipped: '跳过',
  conflicts: '冲突',
  conflictsDesc: '这些用户在 LDAP 和本地都存在但信息不匹配',
  errorDetails: '错误详情',
  andMore: '还有',
  moreErrors: '个错误',
  
  // 搜索和筛选
  searchPlaceholder: '搜索用户...',
  allStatus: '所有状态',
  filtered: '已筛选',
  
  // 状态
  statusActive: '活跃',
  statusInactive: '未激活',
  statusSuspended: '已停用',
  
  // 表格
  employee: '员工',
  source: '来源',
  actions: '操作',
  local: '本地',
  totalUsers: '共',
  
  // 提示
  noUsers: '暂无用户',
  noUsersDesc: '点击上方按钮创建用户或同步 LDAP',
  
  // 表单字段
  basicInfo: '基本信息',
  accountInfo: '账号信息',
  personalInfo: '个人信息',
  username: '用户名',
  usernameHint: '用于登录，仅支持字母、数字、下划线',
  usernamePlaceholder: '请输入用户名',
  password: '密码',
  passwordHint: '至少6位字符',
  passwordPlaceholder: '请输入密码',
  email: '邮箱',
  emailPlaceholder: '请输入邮箱',
  displayName: '显示名称',
  displayNamePlaceholder: '请输入显示名称',
  phone: '手机号',
  phonePlaceholder: '请输入手机号',
  employeeId: '工号',
  employeeIdPlaceholder: '请输入工号',
  department: '部门',
  selectDepartment: '请选择部门',
  position: '职位',
  selectPosition: '请选择职位',
  deptTitle: '部门内头衔', // ✅ 新增：部门内头衔
  titlePlaceholder: '例如：技术负责人',
  manager: '直属上级',
  selectManager: '请选择直属上级（可选）',
  selectDepartmentFirst: '请先选择部门',
  noManager: '该部门暂无其他可选上级',
  status: '状态',
  hiredAt: '入职日期',

  // 用户详情页（v2.4：SSO 绑定信息只读分块）
  detail: {
    sso: {
      sectionTitle: 'SSO 绑定信息',
      externalId: '外部身份 ID',
      externalSource: '外部身份来源',
      lastLoginAt: '最近 SSO 登录时间',
      source: {
        entra: 'Microsoft Entra',
        ldap: 'LDAP',
        ldapPending: 'LDAP / 待 SSO 升级',
        none: '未绑定',
      },
      neverLoggedIn: '从未通过 SSO 登录',
      copyId: '复制 ID',
      copiedToast: '已复制到剪贴板',
    },
  },
};

export type UsersTranslations = typeof usersZh;
